import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectIsShowNotification, selectSavedOfferId } from '../../selectors';
import { TooltipContainer } from '../TooltipContainer';
export function FavoriteButtonWrapperContainer(_ref) {
  var offerId = _ref.offerId,
      placement = _ref.placement,
      children = _ref.children,
      onClickFolderName = _ref.onClickFolderName;
  var buttonRef = React.useRef(null);
  var isTooltipVisible = useSelector(selectIsShowNotification);
  var savedOfferIds = useSelector(selectSavedOfferId);
  var isOfferSelected = savedOfferIds.length === 1 && savedOfferIds[0] === offerId;

  var handleClick = function handleClick(e) {
    e.stopPropagation();
  };

  return /*#__PURE__*/React.createElement("div", {
    onClick: handleClick
  }, /*#__PURE__*/React.createElement("div", {
    ref: buttonRef
  }, children), isTooltipVisible && isOfferSelected && /*#__PURE__*/React.createElement(TooltipContainer, {
    buttonRef: buttonRef,
    placement: placement,
    onClickFolderName: onClickFolderName
  }));
}